import clsx from 'clsx'

type QuoteProps = {
  children: string
  cite?: string
  /**
   * default 'small'
   */
  size?: 'small' | 'medium' | 'large'
}
export const Quote = ({ children, cite, size }: QuoteProps) => {
  const autoSize = size ?? 'medium'

  return (
    <blockquote className={clsx('pull', autoSize)}>
      <span className="quote-mark" aria-hidden="true">
        “
      </span>
      <p>{children}</p>
      {cite && <cite>{cite}</cite>}
    </blockquote>
  )
}
